import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Demo user emails for checking demo mode
const DEMO_EMAILS = [];

/**
 * Check if a user is a demo user based on their email
 * @param {Object|null} user - User object with email property
 * @returns {boolean} - True if user is a demo user
 */
export function isDemoUser(user) {
  if (!user || !user.email) return false;
  return DEMO_EMAILS.includes(user.email);
}

/**
 * Converts a Tailwind text color class to a hex color for inline styles.
 * Example: 'text-emerald-600' -> '#10b981' (approximate)
 * @param {string} textClass - Tailwind text color class (e.g., 'text-emerald-600')
 * @returns {string} - Hex color or empty string
 */
export function tailwindTextToHex(textClass) {
  if (!textClass || typeof textClass !== 'string') return '';
  
  const colorMap = {
    'text-emerald-600': '#059669',
    'text-amber-600': '#d97706',
    'text-blue-600': '#2563eb',
    'text-red-600': '#dc2626',
    'text-gray-600': '#4b5563',
    'text-green-600': '#16a34a',
    'text-yellow-600': '#ca8a04',
    'text-orange-600': '#ea580c',
    'text-purple-600': '#9333ea',
    'text-pink-600': '#db2777',
    'text-indigo-600': '#4f46e5',
    'text-teal-600': '#0d9488',
    'text-cyan-600': '#0891b2',
  };
  
  return colorMap[textClass] || '';
}

/**
 * Converts a Tailwind text color class to a background color class.
 * Example: 'text-emerald-800' -> 'bg-emerald-100'
 * @param {string} textClass - Tailwind text color class
 * @returns {string} - Tailwind background color class
 */
export function tailwindTextToBg(textClass) {
  if (!textClass || typeof textClass !== 'string') return '';
  
  // Use regex for global replacement of text- to bg- and 800 to 100
  return textClass
    .replace(/^text-/g, 'bg-')
    .replace(/800$/g, '100');
}
